import { Splitter, SplitterPanel } from 'primereact/splitter';
import DocumentView from '../../../common/DocumentView';

const SellerPOAndPISplitView = (props) => {
    const { sellerPOURL, sellerPIDoc } = props

    const renderDocument = (docURL) => {
        return (
            <>
                {
                    docURL ?
                        <DocumentView fileUrl={docURL} showZoomControl={true} />
                        : <p>The document file is not found</p>
                }
            </>
        )
    }

    return (
        <div style={{ height: 'calc(100vh - 100px)' }}>
            <Splitter style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                <SplitterPanel style={{ width: '50%', height: '88%', overflow: 'hidden' }}>
                    {renderDocument(sellerPOURL)}
                </SplitterPanel>
                <SplitterPanel style={{ width: '50%', height: '88%', overflow: 'hidden' }}>
                    {renderDocument(sellerPIDoc)}
                </SplitterPanel>
            </Splitter>
            <style>
                {` .p-splitter-gutter { display: none !important; } `}
            </style>
        </div>
    )
}

export default SellerPOAndPISplitView